import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../shared/services/loader.service';
import { ApiService } from '../../shared/services/api.service';
import { Subscription } from 'rxjs';
import { ThisReceiver } from '@angular/compiler';

@Component({
  selector: 'app-spare-parts-filter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './spare-parts-filter.component.html',
  styleUrl: './spare-parts-filter.component.scss',
})
export class SparePartsFilterComponent {
  // Custom dropdown and manual entry fields
  brandText: string = '';
  modelText: string = '';
  yearText: string = '';
  variantText: string = '';

  customFilteredBrands: string[] = [];
  customFilteredModels: string[] = [];
  customFilteredYears: string[] = [];
  customFilteredVariants: string[] = [];

  showCustomBrandDropdown: boolean = false;
  showCustomModelDropdown: boolean = false;
  showCustomYearDropdown: boolean = false;
  showCustomVariantDropdown: boolean = false;
  // Initialize filtered lists on component init
  // Custom dropdown initialization
  customInitDropdowns() {
    this.customFilteredBrands = this.brands.map((b) => b.name);
    this.customFilteredModels = [];
    this.customFilteredYears = this.years.map((y) => y.toString());
    this.customFilteredVariants = [];
  }

  // Custom filter methods
  customFilterBrands() {
    const term = this.brandText.toLowerCase();
    this.customFilteredBrands = this.brands
      .map((b) => b.name)
      .filter((name) => name.toLowerCase().includes(term));
  }

  customFilterModels() {
    const term = this.modelText.toLowerCase();
    this.customFilteredModels = (this.selectedBrandmodelList || [])
      .flatMap((group: any) => group.models)
      .filter((model: string) => model.toLowerCase().includes(term));
  }

  customFilterYears() {
    const term = this.yearText.toLowerCase();
    this.customFilteredYears = this.years
      .map((y) => y.toString())
      .filter((y) => y.includes(term));
  }

  customFilterVariants() {
    const term = this.variantText.toLowerCase();
    this.customFilteredVariants = (this.selectedModelVariantList || []).filter(
      (variant: string) => variant.toLowerCase().includes(term),
    );
  }

  // Select methods
  customSelectBrand(option: string) {
    this.brandText = option;
    this.searchData.brand = option;
    this.showCustomBrandDropdown = false;
    this.resetDownstreamFields();
    this.isModelEnabled = true;
    this.getModelVehicleList(option);
    this.customFilterModels();
    this.updateButtonState();
  }

  customSelectModel(option: string) {
    this.modelText = option;
    this.searchData.model = option;
    this.showCustomModelDropdown = false;
    this.isYearEnabled = true;
    this.isVariantEnabled = true;
    this.getYear();
    this.getVariantVehicleList(option);
    this.customFilterYears();
    this.customFilterVariants();
    this.updateButtonState();
  }

  customSelectYear(option: string) {
    this.yearText = option;
    this.searchData.year = option;
    this.showCustomYearDropdown = false;
    this.isVariantEnabled = true;
    this.getVariantVehicleList(this.searchData.model);
    this.customFilterVariants();
    this.updateButtonState();
  }

  customSelectVariant(option: string) {
    this.variantText = option;
    this.searchData.variant = option;
    this.showCustomVariantDropdown = false;
    this.updateButtonState();
    this.getVehicle();
  }

  // Hide dropdown on blur
  customHideDropdown(type: string) {
    setTimeout(() => {
      if (type === 'brand') this.showCustomBrandDropdown = false;
      if (type === 'model') this.showCustomModelDropdown = false;
      if (type === 'year') this.showCustomYearDropdown = false;
      if (type === 'variant') this.showCustomVariantDropdown = false;
    }, 200);
  }
  // searchEvent = new EventEmitter<VehicleSearch>();
  @ViewChild('brandInput') brandInput!: ElementRef;
  @ViewChild('modelInput') modelInput!: ElementRef;
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  @ViewChild('dropdownContainermodel') dropdownContainermodel!: ElementRef;
  @ViewChild('variantInput') variantInput!: ElementRef;
  @ViewChild('dropdownContainervariant') dropdownContainervariant!: ElementRef;
  @ViewChild('dropdownContainerYear') dropdownContainerYear!: ElementRef;
  @ViewChild('dropdownYear') dropdownYear!: ElementRef;
  @ViewChild('registrationInput') registrationInput!: ElementRef;
  sub: Subscription = new Subscription();
  searchData: VehicleSearch = {};
  dropdownVisibleYear = false;
  vehicleRegex = /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/;
  isValidRegistrationNo = false;

  years: any[] = [];

  brands = [
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d99f132bcd5ba1648f49b2f0504471a2bfc63182?placeholderIfAbsent=true',
      name: 'Tata',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/4854c1a30cca6bf3d61fc8c5fb3bac9f6e6e8f5f?placeholderIfAbsent=true',
      name: 'Suzuki',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      name: 'Audi',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d3fa6771e9469bd85b1a595ea3273cc97bf4d359?placeholderIfAbsent=true',
      name: 'Ashok Leyland',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3310ac8d2789ddcd4fb8b98dc257aa8ea7552313?placeholderIfAbsent=true',
      name: 'Volkswagen',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/7fa4ff48b5f0b8229e9e1b2edffd7e79a48cae3a?placeholderIfAbsent=true',
      name: 'Toyota',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/963abfb9a9ccbbb2ebe0778f0c256ca253e31bd1?placeholderIfAbsent=true',
      name: 'Mercedes',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/bb655f0d30952da04de2620bcbe03b2c94127d24?placeholderIfAbsent=true',
      name: 'Lexus',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/2ea9c47bf0fa448d7f366a697abea74c9d9a18f7?placeholderIfAbsent=true',
      name: 'Kia',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/e44d078afb0956f88d21a7fe798dfc8076283b59?placeholderIfAbsent=true',
      name: 'Hyundai',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d3fa6771e9469bd85b1a595ea3273cc97bf4d359?placeholderIfAbsent=true',
      name: 'Ashok Leyland',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/9f213b52fa9dbd02fec68fe765448ed8cff7c9b8?placeholderIfAbsent=true',
      name: 'Ford',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/8432f50ea8f00b208faed48fa8f4b603c7a319c2?placeholderIfAbsent=true',
      name: 'BMW',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3e84b67fbb8012fe125236b3d171e6572f240f22?placeholderIfAbsent=true',
      name: 'Chevrolet',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/ad9663eb9c87fcb5002bb04412c2eca8c898a634?placeholderIfAbsent=true',
      name: 'Hero',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/e44d078afb0956f88d21a7fe798dfc8076283b59?placeholderIfAbsent=true',
      name: 'Hyundai',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/4854c1a30cca6bf3d61fc8c5fb3bac9f6e6e8f5f?placeholderIfAbsent=true',
      name: 'Suzuki',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      name: 'Audi',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d3fa6771e9469bd85b1a595ea3273cc97bf4d359?placeholderIfAbsent=true',
      name: 'Ashok Leyland',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3310ac8d2789ddcd4fb8b98dc257aa8ea7552313?placeholderIfAbsent=true',
      name: 'Volkswagen',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/7fa4ff48b5f0b8229e9e1b2edffd7e79a48cae3a?placeholderIfAbsent=true',
      name: 'Toyota',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/963abfb9a9ccbbb2ebe0778f0c256ca253e31bd1?placeholderIfAbsent=true',
      name: 'Mercedes',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/bb655f0d30952da04de2620bcbe03b2c94127d24?placeholderIfAbsent=true',
      name: 'Lexus',
    },
  ];

  // popularBrands = [
  //   {
  //     name: 'Chevrolet',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/96f6ecff1103057f53d9e01a9be5508fd6e429c0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'BMW',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/f6d8abdca3c49f8ea13f2b71f57f789e48667859?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Tata - Motors Commercial',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/4acd3ba184f111166bcb8e30f6f1ad9af1cb2d39?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Hero',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/dff264fcc3930a932be8f70e8703b3f4bfd7aa22?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Hyundai',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/b671f7d9c5be99e3336b1f0ffc39a66e65bf9242?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Kia',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/ba042ef54c855a57e47e790cc6aa36cc7f40f68b?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Suzuki',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/0a9820e1437750574418aeb61360e0b54397737b?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Ford',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/1b0ec491d80cc63bb2135c40e3e0e5fe72a17d7e?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  //   {
  //     name: 'Lexus',
  //     imageUrl:
  //       'https://cdn.builder.io/api/v1/image/assets/TEMP/a5fa28ea89e5f31a6fe270956b41cfaf4f5aff40?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
  //   },
  // ];
  dropdownVisible = false;
  dropdownVisiblemodel = false;
  dropdownVisiblevariant = false;
  searchEvent: any;
  showVehiclePopup = false;
  vehicleTitle = 'Tata Ace Gold, 2017, 1.4L (BS-IV, Diesel)';
  vehicleImage =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/1b7d948e33a2c1d90c482039e4f08330af60fdea?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  closeIconUrl =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/e3f9dae9aedb57f6f7418ae326e3bda1a77ba4e0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  vehicleDetails: any;

  modelList: any = {};
  brandsList: any[] = [];
  filteredBrandsList: any[] = [];
  selectedBrandmodelList: any[] = [];
  selectedModelVariantList: any[] = [];
  isLoadingBrands = false;
  searchTimeout: any;
  isUserTyping = false;
  isHoveringBrand = false;
  scrollPosition = 0;

  // Variant dropdown data
  fuelTypes = ['Petrol', 'Diesel', 'CNG'];
  selectedFuelType = '';
  variantData = {
    fuelTypes: ['Petrol', 'Diesel', 'CNG'],
    variants: ['1.5L (BS4-Diesel)'],
  };

  // Field enable/disable states
  isModelEnabled = false;
  isYearEnabled = false;
  isVariantEnabled = false;
  isButtonEnabled = false;
  modelimages: any;
  showErrorToast = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private apiService: ApiService,
  ) {
    // Generate years for the dropdown (e.g., last 30 years)
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 30; i++) {
      this.years.push(currentYear - i);
    }
  }

  ngOnInit() {
    // Years already generated in constructor
    this.getBrandVehicleList();

    // Set initial field states
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.updateButtonState();
  }

  ngOnDestroy() {
    // Clear timeout to prevent memory leaks
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.sub.unsubscribe();
    // Ensure body scroll is unlocked when component is destroyed
    this.unlockBodyScroll();
  }

  resetDownstreamFields() {
    // Reset all fields that come after the current selection
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.updateButtonState();
  }

  handleClose() {
    this.showVehiclePopup = false;
    this.unlockBodyScroll();
    this.handleCancel();
  }

  handleCancel() {
    this.showVehiclePopup = false;
    this.unlockBodyScroll();
    this.searchData.brand = '';
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.searchData.registrationNo = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
  }

  handleConfirm() {
    localStorage.removeItem('category');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('filterState');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.setItem(
      'SpareCategory',
      JSON.stringify(this.vehicleDetails?.Vehicle_Data[0]),
    );
    // localStorage.setItem('categoryType', JSON.stringify('spareParts'));
    // Do something with confirmation
    this.showVehiclePopup = false;
    this.unlockBodyScroll();
    this.searchData.brand = '';
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.router.navigate(['/product-list']);
  }

  openVehiclePopup() {
    this.showVehiclePopup = true;
    this.lockBodyScroll();
  }

  lockBodyScroll(): void {
    // Prevent body scroll when popup is open
    if (typeof document !== 'undefined') {
      // Save current scroll position
      this.scrollPosition =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      // Apply styles to prevent scrolling while maintaining scroll position
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';

      // Prevent touch scrolling on mobile devices
      document.body.addEventListener('touchmove', this.preventScroll, {
        passive: false,
      });
    }
  }

  unlockBodyScroll(): void {
    // Restore body scroll when popup is closed
    if (typeof document !== 'undefined') {
      // Remove touch scroll prevention
      document.body.removeEventListener('touchmove', this.preventScroll);

      // Remove the fixed positioning styles
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      // Restore scroll position
      window.scrollTo(0, this.scrollPosition);
    }
  }

  preventScroll = (e: TouchEvent): void => {
    // Allow scrolling within the popup content, but prevent background scrolling
    const target = e.target as HTMLElement;
    const popup = target.closest('main[class*="fixed"]');
    if (!popup) {
      e.preventDefault();
    }
  };

  handleOverlayClick(event: MouseEvent): void {
    // Prevent any scrolling when clicking on the overlay
    event.preventDefault();

    // Close popup when clicking on the overlay background
    // The article element stops propagation, so if we reach here, it's the overlay
    this.handleClose();
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Only check if we clicked completely outside all dropdown-related elements
    const clickedOutside =
      !this.dropdownContainer?.nativeElement?.contains(target) &&
      !this.brandInput?.nativeElement?.contains(target) &&
      !this.dropdownContainermodel?.nativeElement?.contains(target) &&
      !this.modelInput?.nativeElement?.contains(target) &&
      !this.dropdownContainervariant?.nativeElement?.contains(target) &&
      !this.variantInput?.nativeElement?.contains(target) &&
      !this.dropdownContainerYear?.nativeElement?.contains(target) &&
      !this.dropdownYear?.nativeElement?.contains(target);

    if (clickedOutside) {
      this.dropdownVisible = false;
      this.dropdownVisiblemodel = false;
      this.dropdownVisiblevariant = false;
      this.dropdownVisibleYear = false;
    }
  }

  openDropdown(): void {
    this.dropdownVisible = true;
    this.dropdownVisiblemodel = false;
    this.dropdownVisiblevariant = false;
    this.dropdownVisibleYear = false;
    // Reset filtered brands list to show all brands when dropdown is opened
    this.filteredBrandsList = [...this.brandsList];
  }

  openDropdownmodel(): void {
    if (!this.isModelEnabled) return;
    this.dropdownVisible = false;
    this.dropdownVisiblemodel = true;
    this.dropdownVisiblevariant = false;
    this.dropdownVisibleYear = false;
  }

  openDropdownvariant(): void {
    if (!this.isVariantEnabled) return;
    this.dropdownVisible = false;
    this.dropdownVisiblemodel = false;
    this.dropdownVisiblevariant = true;
    this.dropdownVisibleYear = false;
    if (this.searchData.model) {
      // Get variants for the selected model if not already loaded
      if (
        !this.selectedModelVariantList ||
        this.selectedModelVariantList.length === 0
      ) {
        this.getVariantVehicleList(this.searchData.model);
      }
    }
  }

  search(): void {
    this.searchData.model = '';
    this.searchEvent.emit(this.searchData);
  }

  selectBrand(name: string) {
    this.searchData.brand = name;
    this.dropdownVisible = false;

    // Reset filtered brands list to show all brands
    this.filteredBrandsList = [...this.brandsList];

    // Reset downstream fields
    this.resetDownstreamFields();

    // Enable model field when brand is selected
    this.isModelEnabled = true;

    // Get models for the selected brand
    this.getModelVehicleList(name);

    // Update button state
    this.updateButtonState();
  }

  selectModel(model: string) {
    this.searchData.model = model;
    this.dropdownVisiblemodel = false;

    // Reset year and variant fields
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isYearEnabled = true;
    this.isVariantEnabled = true;
    this.getYear();
    this.getVariantVehicleList(model);
    this.updateButtonState();
  }

  selectVariant(variant: string) {
    this.searchData.variant = variant;
    // Get vehicle details for the selected variant
    this.getVehicle();
  }

  selectFuelType(fuelType: string) {
    this.selectedFuelType = fuelType;
    // Filter variants based on selected fuel type
    this.filterVariantsByFuelType(fuelType);
  }

  clearFuelTypeFilter() {
    this.selectedFuelType = '';
    this.variantData.variants = this.selectedModelVariantList;
  }

  filterVariantsByFuelType(fuelType: string) {
    // Filter variants that contain the selected fuel type
    if (fuelType) {
      this.variantData.variants = this.selectedModelVariantList.filter(
        (variant) => variant.toLowerCase().includes(fuelType.toLowerCase()),
      );
    } else {
      // If no fuel type selected, show all variants
      this.variantData.variants = this.selectedModelVariantList;
    }
  }

  selectVariantFromDropdown(variant: string) {
    this.searchData.variant = variant;
    this.dropdownVisiblevariant = false;
    this.updateButtonState();
  }

  onYearChange() {
    // Enable variant field when year is selected
    if (this.searchData.year) {
      this.getVariantVehicleList(this.searchData.model);
      this.isVariantEnabled = true;
    } else {
      this.isVariantEnabled = false;
      this.searchData.variant = '';
    }
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 30; i++) {
      this.years.push(currentYear - i);
    }
  }

  getBrandVehicleList() {
    this.isLoadingBrands = true;
    this.loaderService.show();
    const payload = {
      action_type: 'make',
    };
    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (response: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          if (response && response.data) {
            this.modelList = response?.data?.Vehicle_Brands;
            this.brandsList = this.transformModelListToBrandsList(
              this.modelList,
            );
            this.filteredBrandsList = [...this.brandsList]; // Initialize filtered list with all brands
          }
        },
        error: (error: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          console.error('Error fetching brand list:', error);
        },
      }),
    );
  }

  // Filter brands based on user input
  // This method filters the brands list to show only brands that start with the search term
  filterBrands(searchTerm: string): void {
    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredBrandsList = [...this.brandsList];
      return;
    }

    const searchLower = searchTerm.toLowerCase().trim();
    const filteredList: any[] = [];

    this.brandsList.forEach((column) => {
      const filteredColumn = column.filter((section: any) => {
        // Check if any brand in this section starts with the search term
        return section.brands.some((brand: string) =>
          brand.toLowerCase().startsWith(searchLower),
        );
      });

      if (filteredColumn.length > 0) {
        // Create a new column with only the matching sections
        const newColumn = filteredColumn.map((section: any) => ({
          letter: section.letter,
          brands: section.brands.filter((brand: string) =>
            brand.toLowerCase().startsWith(searchLower),
          ),
        }));
        filteredList.push(newColumn);
      }
    });

    this.filteredBrandsList = filteredList;
  }

  // Transform modelList to a format suitable for the template
  transformModelListToBrandsList(modelList: any): any[] {
    const transformedList: any[] = [];

    // Sort the keys alphabetically
    const sortedKeys = Object.keys(modelList).sort();

    // Group brands into columns (7 columns as in the original template)
    const brandsPerColumn = Math.ceil(sortedKeys.length / 7);

    for (let i = 0; i < sortedKeys.length; i += brandsPerColumn) {
      const column = sortedKeys.slice(i, i + brandsPerColumn).map((letter) => ({
        letter: letter.toUpperCase(),
        brands: modelList[letter] || [],
      }));
      transformedList.push(column);
    }

    return transformedList;
  }

  // Get popular brands from the modelList data
  getPopularBrands(searchTerm?: string): any[] {
    if (!this.modelList) return [];

    const popularBrandNames = [
      'TATA',
      'MARUTI',
      'HYUNDAI',
      'HONDA',
      'TOYOTA',
      'BMW',
      'AUDI',
      'MERCEDES',
    ];
    const popularBrands: any[] = [];

    // Create a mapping of brand names to their default images
    const brandImageMap: { [key: string]: string } = {
      TATA: 'https://cdn.builder.io/api/v1/image/assets/TEMP/d99f132bcd5ba1648f49b2f0504471a2bfc63182?placeholderIfAbsent=true',
      MARUTI:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/4854c1a30cca6bf3d61fc8c5fb3bac9f6e6e8f5f?placeholderIfAbsent=true',
      HYUNDAI:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/e44d078afb0956f88d21a7fe798dfc8076283b59?placeholderIfAbsent=true',
      HONDA:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      TOYOTA:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/7fa4ff48b5f0b8229e9e1b2edffd7e79a48cae3a?placeholderIfAbsent=true',
      BMW: 'https://cdn.builder.io/api/v1/image/assets/TEMP/8432f50ea8f00b208faed48fa8f4b603c7a319c2?placeholderIfAbsent=true',
      AUDI: 'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      MERCEDES:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/963abfb9a9ccbbb2ebe0778f0c256ca253e31bd1?placeholderIfAbsent=true',
    };

    // Find brands from modelList that match popular brand names
    for (const brandName of popularBrandNames) {
      // If search term is provided, only include brands that start with the search term
      if (
        searchTerm &&
        !brandName.toLowerCase().startsWith(searchTerm.toLowerCase())
      ) {
        continue;
      }

      for (const letter in this.modelList) {
        if (this.modelList[letter].includes(brandName)) {
          popularBrands.push({
            name: brandName,
            imageUrl:
              brandImageMap[brandName] ||
              'https://cdn.builder.io/api/v1/image/assets/TEMP/d99f132bcd5ba1648f49b2f0504471a2bfc63182?placeholderIfAbsent=true',
          });
          break;
        }
      }
    }

    return popularBrands;
  }

  getModelVehicleList(selectedBrand?: string) {
    const payload = {
      action_type: 'model',
      make_list: [selectedBrand || this.searchData.brand || ''],
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe((res: any) => {
        if (res?.data?.Vehicle_Models) {
          const modelData = res?.data?.Vehicle_Models;

          // Merge both numeric and letter key arrays into one flat array
          const allModels = [
            ...Object.keys(modelData)
              .filter((key) => /^\d+$/.test(key) || /^[a-zA-Z]$/.test(key))
              .flatMap((key) => modelData[key]),
          ];

          // Group all models alphabetically (A-Z)
          const modelsByLetter = this.groupModelsAlphabetically(allModels);

          this.selectedBrandmodelList = modelsByLetter; // Now just an array of { letter: string, models: string[] }

          this.modelimages = res?.data?.image_data;
        } else {
          this.selectedBrandmodelList = [];
        }
        this.loaderService.hide();
      }),
    );
  }

  // Helper method to group models alphabetically
  groupModelsAlphabetically(models: string[]): any[] {
    const grouped: { [key: string]: string[] } = {};

    models.forEach((model) => {
      const firstLetter = model.charAt(0).toUpperCase();
      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }
      grouped[firstLetter].push(model);
    });

    // Convert to array format and sort
    return Object.keys(grouped)
      .sort()
      .map((letter) => ({
        letter: letter,
        models: grouped[letter].sort(),
      }));
  }

  getVariantVehicleList(selectedModel?: string) {
    const payload = {
      action_type: 'variant',
      make_list: [this.searchData.brand || ''],
      model_list: [selectedModel || this?.searchData?.model || ''],
      variant_list: [],
      year_of_manufacture: this.searchData?.year || '',
      offset: 0,
      limit: 10,
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe((res: any) => {
        // Transform the response to handle both numeric and letter keys
        if (res?.data) {
          const variantData = res?.data?.Vehicle_Variant;
          const allVariants: string[] = [];

          // Extract all variants from the response (both numeric and letter keys)
          Object.keys(variantData).forEach((key) => {
            if (Array.isArray(variantData[key])) {
              allVariants.push(...variantData[key]);
            }
          });

          // Sort variants alphabetically for better user experience
          this.selectedModelVariantList = allVariants.sort((a, b) =>
            a.localeCompare(b),
          );

          // Update the variant data for the dropdown
          this.variantData.variants = this.selectedModelVariantList;
        } else {
          this.selectedModelVariantList = [];
          this.variantData.variants = [];
        }

        this.loaderService.hide();
      }),
    );
  }

  getVehicle() {
    const payload = {
      action_type: 'Get Vehicle Details',
      make_list: [this.searchData.brand || ''],
      model_list: [this.searchData.model || ''],
      variant_list: [this.searchData.variant || ''],
      year_of_manufacture: this.searchData?.year || '',
      offset: 0,
      limit: 10,
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe((res: any) => {
        if (res.success) {
          this.onAdd();
          this.openVehiclePopup();
          this.vehicleDetails = res?.data;
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }),
    );
  }

  toggleYearGrid() {
    if (!this.isYearEnabled) return;
    this.dropdownVisibleYear = true;
  }

  openYearDropdown() {
    if (!this.isYearEnabled) return;
    this.dropdownVisible = false;
    this.dropdownVisiblemodel = false;
    this.dropdownVisiblevariant = false;
    this.dropdownVisibleYear = true;
  }

  selectYear(year: number) {
    this.searchData.year = year.toString();
    this.dropdownVisibleYear = false;
    this.onYearChange();
    this.updateButtonState();
  }

  updateButtonState() {
    // Enable button if either:
    // 1. Registration number is valid (8+ characters and matches regex), OR
    // 2. Brand and model are selected
    const hasValidRegistrationNo = !!(
      this.searchData.registrationNo &&
      this.searchData.registrationNo.length >= 8 &&
      this.isValidRegistrationNo
    );
    const hasBrandAndModel = !!(
      this.searchData.brand &&
      this.searchData.model &&
      this.searchData.variant &&
      this.searchData.year
    );

    this.isButtonEnabled = hasBrandAndModel;
  }

  onRegistrationNoChange(): void {
    this.updateButtonState();

    // Reset validation state
    this.isValidRegistrationNo = false;

    // If registration number is cleared or less than 8 characters, reset all bound values
    if (
      !this.searchData.registrationNo ||
      this.searchData.registrationNo.length != 10
    ) {
      this.resetRegistrationNoBoundValues();
      return;
    }

    // Clear brand when registration number is entered
    if (this.searchData.registrationNo) {
      this.searchData.brand = '';
    }

    // Check if registration number has exactly 8 or more characters and validate with regex
    if (this.searchData.registrationNo.length == 10) {
      const registrationNoUpper = this.searchData.registrationNo.toUpperCase();
      const isValid = this.vehicleRegex.test(registrationNoUpper);
      this.isValidRegistrationNo = isValid;

      if (isValid) {
        // Update registration number to uppercase
        this.searchData.registrationNo = registrationNoUpper;
        // Make API call only when regex matches and has 8+ characters
        this.getVehicleDetailsByRegistration(registrationNoUpper);

        // Close keyboard on mobile when registration number is complete
        if (this.registrationInput?.nativeElement) {
          setTimeout(() => {
            this.registrationInput.nativeElement.blur();
          }, 100);
        }
      } else {
        // If invalid, reset bound values
        this.resetRegistrationNoBoundValues();
      }
    }
  }

  resetRegistrationNoBoundValues(): void {
    // Reset all values that were bound from API response
    this.searchData.brand = '';
    this.brandText = '';
    this.searchData.variant = '';
    this.variantText = '';
    this.searchData.model = '';
    this.modelText = '';
    this.searchData.year = '';
    this.yearText = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.updateButtonState();
  }

  getVehicleDetailsByRegistration(registrationNo: string): void {
    const payload = {
      reg_no: registrationNo,
      action_type: 'Get Vehicle Details',
    };

    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.loaderService.hide();

            if (res && res.data) {
              // Bind response data to form fields
              if (res.data.Vehicle_Data[0]) {
                this.searchData.brand = res.data.Vehicle_Data[0].VEHICLE_MAKE_s;
                this.brandText = res.data.Vehicle_Data[0].VEHICLE_MAKE_s;
                this.searchData.variant = res.data.Vehicle_Data[0].VARIANT_s;
                this.variantText = res.data.Vehicle_Data[0].VARIANT_s;
                this.searchData.model = res.data.Vehicle_Data[0].PARENT_MODEL_s;
                this.modelText = res.data.Vehicle_Data[0].PARENT_MODEL_s;
                this.searchData.year =
                  res.data.Vehicle_Data[0].YEAR_OF_MANUFACTURE_s;
                this.yearText = res.data.Vehicle_Data[0].YEAR_OF_MANUFACTURE_s;
                this.isModelEnabled = true;
              }

              if (
                res.data.Vehicle_Data[0].VEHICLE_MAKE_s &&
                res.data.Vehicle_Data[0].PARENT_MODEL_s &&
                res.data.Vehicle_Data[0].VARIANT_s &&
                res.data.Vehicle_Data[0].YEAR_OF_MANUFACTURE_s
              ) {
                this.getVehicle();
              }

              // Update button state after binding
              this.updateButtonState();
            }
          } else {
            this.loaderService.hide();
            this.showVehiclePopup = true;
            this.lockBodyScroll();
          }
        },
        error: (error: any) => {
          this.loaderService.hide();
          console.error('Error fetching vehicle details:', error);
          this.showVehiclePopup = true;
          this.lockBodyScroll();
        },
      }),
    );
  }

  hideErrorToast(): void {
    this.showErrorToast = false;
  }

  onBrandChange(): void {
    // Since brand input is now readonly, this method is mainly for compatibility
    if (this.searchData.brand) {
      this.searchData.registrationNo = '';
    }
    // Always show all brands since we're not typing
    this.filteredBrandsList = [...this.brandsList];
  }

  onAdd() {
    const payload = {
      part_no: '',
      model: this.searchData?.model || '',
      make: this.searchData?.brand || '',
      vehicle_variant: this.searchData?.variant || '',
      year: this.searchData?.year || '',
      fuel_type: '',
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.addModelSearch(payload).subscribe((res: any) => {
        if (res.success) {
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }),
    );
  }

  getYear() {
    this.isLoadingBrands = true;
    this.loaderService.show();
    const payload = {
      // "dropdown_type": "vehicle_brand"
      action_type: 'year_of_manufacture',
      make_list: [this.searchData.brand || ''],
      model_list: [this.searchData.model || ''],
      variant_list: '', //[this.searchData.variant || ""],
      year_of_manufacture: this.searchData?.year || '',
      offset: 0,
      limit: 1000,
    };
    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (response: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          if (response && response.data) {
            this.years = response?.data?.Vehicle_Year?.map(
              (item: any) => item?.YEAR_OF_MANUFACTURE_s,
            );
          }
        },
        error: (error: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          console.error('Error fetching brand list:', error);
        },
      }),
    );
  }

  // Handle input focus - stop scrolling when typing
  onInputFocus(): void {
    this.isUserTyping = true;
  }

  // Handle input blur - resume scrolling when not typing
  onInputBlur(): void {
    this.isUserTyping = false;
  }

  // Handle brand icon hover
  onBrandHover(isHovering: boolean): void {
    this.isHoveringBrand = isHovering;
  }

  // Check if scrolling should be paused
  get shouldPauseScroll(): boolean {
    return this.isUserTyping || this.isHoveringBrand;
  }

  preventInvalidInput(event: any) {
    let value = event.target.value;

    // Block leading space
    value = value.replace(/^\s+/, '');

    // Block special characters (allow only A-Z and 0-9)
    value = value.replace(/[^A-Za-z0-9]/g, '');

    // Convert to uppercase automatically
    value = value.toUpperCase();

    event.target.value = value;
    this.searchData.registrationNo = value;
  }
}
export interface VehicleSearch {
  registrationNo?: string;
  brand?: string;
  model?: string;
  year?: string;
  variant?: string;
}

export interface Brand {
  name: string;
  imageUrl: string;
}

export interface AlphabetSection {
  letter: string;
  brands: string[];
}
